import { useTranslation } from "react-i18next";
import Header from "./Header";
import Footer from "./Footer";
import PageTopAmbient from "@/components/motion/PageTopAmbient";
import PointerAmbient from "@/components/motion/PointerAmbient";
import CookieConsent from "@/components/common/CookieConsent";
import LangSync from "@/components/common/LangSync";
import StaticUISync from "@/components/common/StaticUISync";

export const Layout = ({ children }) => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col bg-porcelain text-ink">
      <LangSync />
      <StaticUISync />
      <a
        href="#main-content"
        className="sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:block focus:rounded-full focus:bg-ink focus:px-5 focus:py-2.5 focus:text-sm focus:font-medium focus:text-white focus:outline-none focus:ring-2 focus:ring-raspberry/50"
      >
        {t("a11y.skipToContent")}
      </a>
      <Header />
      <main
        id="main-content"
        className="relative flex-1 pt-[5.5rem] sm:pt-[6rem]"
        data-testid="page-main"
        tabIndex={-1}
      >
        <PointerAmbient />
        <PageTopAmbient />
        <div className="relative z-[1]">{children}</div>
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
};

export default Layout;
